import validateCategoryParameters from './validateCategoryParameters';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { default as itemsCategoriesStoreUpdate } from 'owa-mail-actions/lib/triage/itemsCategoriesStoreUpdate';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { selectMailStoreItemById } from 'owa-mail-store';
import * as undoActions from 'owa-mail-undo';
import { handleServiceError } from 'owa-service-error';
import strings from 'owa-strings/owa-mail-strings';
import updateItemsCategoriesService from '../../../services/updateItemsCategoriesService';
import tombstoneOperations from 'owa-mail-list-tombstone';
/**
 * Internal method to update categories
 * @param itemRowKeys the row keys of the items
 * @param tableView that contains the items
 * @param categoriesToAdd the categories to be added to the items
 * @param categoriesToRemove the categories to be removed from the items
 * @param clearCategories whether to clear categories
 * @param actionSource where this action is triggered from
 * @param promiseToWaitUpon promise to wait upon before sending the update category request.
 */
export default function updateItemsCategoriesInternal(itemRowKeys, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource, promiseToWaitUpon) {
    // Validate category parameters and throw error if they are invalid
    validateCategoryParameters(itemRowKeys, categoriesToAdd, categoriesToRemove, clearCategories);
    undoActions.clearLastUndoableAction();
    var itemIdsToUpdate = getRowIdsFromRowKeys(itemRowKeys, tableView.id);
    if (promiseToWaitUpon) {
        // In case where user creates a category from the commanding bar drop down
        // we want to only send the request to apply the category only if the creation of
        // category succeeds. Today the promiseToWaitUpon here is create Category action
        promiseToWaitUpon.then(function (isPromiseSuccessful) {
            submitRequestAndMakeLocalUpdate(itemIdsToUpdate, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource);
        });
    }
    else {
        submitRequestAndMakeLocalUpdate(itemIdsToUpdate, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource);
    }
}
function submitRequestAndMakeLocalUpdate(itemIdsToUpdate, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource) {
    // 1. Update the items categories in store.
    // After items categories got updated we can submit changes to the server.
    itemsCategoriesStoreUpdate(itemIdsToUpdate, categoriesToAdd, categoriesToRemove, clearCategories);
    var itemContexts = createCategoryServiceItemContexts(itemIdsToUpdate);
    // 2. Add category operation to tombstone
    // The local update operation should happen before adding category to tombstone
    // else we may not have correct set of categories when adding it to the tombstone
    addCategoryOperationToTombstone(itemContexts, tableView);
    // 3. submit server request
    submitUpdateItemCategories(itemContexts, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource);
}
function submitUpdateItemCategories(itemContexts, tableView, categoriesToAdd, categoriesToRemove, clearCategories, actionSource) {
    handleServiceError('updateItemsCategoriesInternal', strings.errorUpdatingCategories, function () {
        // Issue service request
        var promiseToReturn = updateItemsCategoriesService(itemContexts).catch(function (e) {
            var datapoint = returnTopExecutingActionDatapoint();
            datapoint.endWithError(DatapointStatus.ServerError);
        });
        // VSO 23862 - Instrumentation for category triage actions
        return promiseToReturn;
    });
}
function addCategoryOperationToTombstone(itemContexts, tableView) {
    // Add each row to the tombstone map
    itemContexts.forEach(function (itemContext) {
        var itemCategories = itemContext.newCategoriesCollection;
        tombstoneOperations.add([itemContext.instanceKey], tableView.serverFolderId, {
            type: 3 /* OnEqualCategories */,
            value: itemCategories ? itemCategories : [],
        });
    });
}
/**
 * Create item contexts for update item category service
 * @param itemIds to be updated
 * @returns an array of UpdateCategoriesItemContext which is used for the service
 */
function createCategoryServiceItemContexts(itemIdsToUpdate) {
    var itemContexts = [];
    itemIdsToUpdate.forEach(function (itemId) {
        var item = selectMailStoreItemById(itemId);
        itemContexts.push({
            itemId: item.ItemId,
            instanceKey: item.InstanceKey,
            newCategoriesCollection: item.Categories,
        });
    });
    return itemContexts;
}
//# sourceMappingURL=updateItemsCategoriesInternal.js.map